import * as React from 'react';
import { MiddlewareSync } from "@sa/rep-common";
import { ComponentProcessingState } from "@sa/rep-react";
import { ComponentChartHistorical } from "../components/ComponentChartHistorical";
import { ComponentChartGrowth } from "../components/ComponentChartGrowth";
import { SlideContext } from "../Context";
import { REPORT_ID } from '../constants';

export const slide33ComponentMiddleware: MiddlewareSync<ComponentProcessingState> = (input, next) => {
  const { identification, componentContext } = input;
  if (REPORT_ID === identification.reportId) {
    if (identification.componentId === "chart-historical") {
      input.component = <ComponentChartHistorical context={componentContext as SlideContext}></ComponentChartHistorical>;
    }
    if (identification.componentId === "chart-growth") {
      input.component = <ComponentChartGrowth context={componentContext as SlideContext}></ComponentChartGrowth>;
    }

  }
  return next(input);
};
